class BaseApiModule {
  public readonly baseUrl: string

  constructor(url: string) {
    if (url.includes('localhost')) {
      this.baseUrl = `http://${url}`
      return
    }
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url
    }
    this.baseUrl = url
  }

  camelToUnderscore(stringValue: string) {
    return stringValue.replace(/([A-Z])/g, '_$1').toLowerCase()
  }
}

export default BaseApiModule
